import { __awaiter, __generator } from "tslib";
import { useCallback, useState } from 'react';
import Api, { getErrorMessage } from '../utilities/Api';
var useApi = function (url, method) {
    var _a = useState(null), response = _a[0], setResponse = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(null), errorMessage = _c[0], setErrorMessage = _c[1];
    var makeRequest = useCallback(function (payload, options) {
        if (payload === void 0) { payload = {}; }
        if (options === void 0) { options = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var onError, onSuccess, apiResponse, requestError_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onError = options.onError, onSuccess = options.onSuccess;
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Api[method](url, payload)];
                    case 2:
                        apiResponse = _a.sent();
                        setErrorMessage(null);
                        setIsLoading(false);
                        setResponse(apiResponse);
                        if (onSuccess) {
                            onSuccess(apiResponse);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        requestError_1 = _a.sent();
                        message = getErrorMessage(requestError_1);
                        setIsLoading(false);
                        setErrorMessage(message);
                        if (onError) {
                            onError(message);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [url, method]);
    return [makeRequest, isLoading, errorMessage, response];
};
var useApiGet = function (url) {
    return useApi(url, 'get');
};
var useApiPost = function (url) {
    return useApi(url, 'post');
};
var useApiPut = function (url) {
    return useApi(url, 'put');
};
var useApiPatch = function (url) {
    return useApi(url, 'patch');
};
var useApiDelete = function (url) {
    return useApi(url, 'delete');
};
export { useApiGet, useApiPatch, useApiPost, useApiPut, useApiDelete };
//# sourceMappingURL=useApi.js.map